<template>
  <b-collapse
    :id="idCollapse"
    class="card-invite card-user"
    v-model="showCollapse"
  >
    <table class="table table-hover table-responsive-md">
      <tbody>
        <tr v-for="tx in txs.list" v-bind:key="tx.id" class="d-flex">
          <td scope="row" class="col-2">
            <div>
              <router-link
                :to="{
                  name: 'CustomerServiceDetailsNew',
                  params: { txid: tx.uuid }
                }"
                ><strong>#{{ tx.id | numeral("00000") }}</strong></router-link
              >
            </div>
            <div class="subtitle">
              {{ tx.dateCreated | moment }}
              {{ tx.dateCreated | moment-hour }}
            </div>
          </td>
          <td class="col-2">
            <img
              v-if="tx.profilePicture"
              :src="tx.profilePicture"
              class="img-avatar img-profile"
              style="height: 50px;"
            />
            <div>
              <div class="subtitle">
                <strong>{{ tx.buyerName }}</strong>
              </div>
              <div class="subtitle">{{ tx.amount | numeral("$ 0,0.00") }}</div>
            </div>
          </td>
          <td class="col-2">
            <div class="subtitle">{{ tx.buyerEmail }}</div>
            <div class="subtitle">{{ tx.buyerPhone }}</div>
          </td>
          <td class="col-2">
            <img
              height="50"
              :src="
                '/static/sellers/' +
                  tx.sellerName[0].toUpperCase() +
                  tx.sellerName
                    .toLowerCase()
                    .replace(/ /g, '_')
                    .slice(1) +
                  '.png'
              "
              class="img-profile"
            />
            <div>
              <div class="subtitle">
                <strong>{{ tx.sellerName }}</strong>
              </div>
              <div class="subtitle">{{ tx.reference }}</div>
            </div>
          </td>
          <td class="col-2">
            <div class="subtitle">
              <strong>{{ tx.currentStep }}</strong>
            </div>
            <div
              class="subtitle"
              v-b-tooltip.hover
              title="Status na loja"
              v-if="tx.sellerStatus"
            >
              <i class="fa fa-shopping-cart"></i>
              <strong>{{ tx.sellerStatus }}</strong>
            </div>
          </td>
          <!--
          <td class="col-2">
            <button-component
              :href="
                'https://api.whatsapp.com/send?phone=55' +
                  tx.buyerPhone +
                  '&text=Olá ' +
                  tx.buyerName +
                  ', tudo bem? Seu parcelamento do pedido ' +
                  tx.id +
                  ' na ' +
                  tx.sellerName +
                  ' foi aprovado e este é o canal de suporte da boleto parcelado BoletoFlex. Aqui você pode tirar dúvidas sobre seu parcelamento, solicitar seus boletos e ' +
                  'nos informar se ocorrer algum problema com seu pedido. Mantendo seus pagamentos em dia, você garante todos os benefícios de proteção de sua compra. Para sua comodidade, ' +
                  'no link abaixo você tem acesso a todos boletos. Conte sempre com a gente. ' +
                  encodeURIComponent('https://meu.boletoflex.com/#/' + tx.uuid)
              "
              target="_blank"
              class="btn btn-outline-success"
            >
              <i class="micon-whatsapp"></i>
            </button-component>
          </td>
          -->
        </tr>
      </tbody>
    </table>
    <b-pagination
      size="md"
      align="center"
      :total-rows="total"
      v-model="currentPage"
      :per-page="max"
      @change="fetchData"
      limit="10"
    >
    </b-pagination>
  </b-collapse>
</template>

<script>
import Button from '../button/Button.vue'
import moment from 'moment-timezone'

export default {
  props: {
    showCollapse: {
      type: Boolean,
      default: true
    },
    idCollapse: {
      type: String,
      default: 'follow-up-list-collapse'
    },
    cpf: {
      type: String
    }
  },
  components: {
    'button-component': Button
  },
  data () {
    return {
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0
    }
  },
  mounted () {
    this.fetchData(1)
  },
  methods: {
    fetchData: function (val) {
      moment.locale('pt-br')
      var page = val || this.currentPage
      this.$http
        .get('api/customerservice/orders', {
          params: {
            offset: this.max * (page - 1),
            max: this.max,
            cpf: this.cpf
          }
        })
        .then(function (res) {
          console.log(res)
          this.txs = res.data
          this.total = res.data.total
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variaveis.scss";
@import "../../../assets/scss/mixins.scss";
@import "../../../assets/scss/card.scss";

.card-user {
  .avatar {
    width: 40px;
  }
  .card-invite-body {
    top: 102px;
  }
}
.img-profile {
  float: left;
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customerservice/FollowUpOrderList.vue